import { useEffect, useState } from 'react';

let chartFocus = {
  clientReferenceId: null,
  pregnancyReferenceId: null,
  activeTab: null,
};

const listeners = new Set();

export function setOpenLaborChartFocus(next) {
  chartFocus = next
    ? {
      clientReferenceId: next.clientReferenceId ?? null,
      pregnancyReferenceId: next.pregnancyReferenceId ?? null,
      activeTab: next.activeTab ?? null,
    }
    : {
      clientReferenceId: null,
      pregnancyReferenceId: null,
      activeTab: null,
    };
  listeners.forEach((listener) => listener(chartFocus));
}

export function getOpenLaborChartFocus() {
  return chartFocus;
}

export function subscribeOpenLaborChartFocus(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useOpenLaborChartFocus() {
  const [focus, setFocus] = useState(() => getOpenLaborChartFocus());

  useEffect(() => subscribeOpenLaborChartFocus(setFocus), []);

  return focus;
}

export function isViewingLaborBirthTab(focus, item) {
  if (!focus || !item || focus.activeTab !== 'birth') return false;
  const clientMatch = String(focus.clientReferenceId || '') === String(item.clientReferenceId || '');
  const pregnancyMatch = String(focus.pregnancyReferenceId || '') === String(item.pregnancyReferenceId || '');
  return clientMatch && pregnancyMatch;
}
